<template>
  <div class="home fill-height">
    <h1 class="indigo--text text--darken-4">Bienvenue sur le site de Cyril Mskine,</h1>
    <div class="text-md-body-1">Développeur web sur Bordeaux</div>
    <p class="text-left caption">(Utilisez l'avatar ci-dessus pour naviguer)</p>
    <v-row>
      <v-col cols="2"></v-col>
      <v-col cols="7" class="text-left">
        Une petite citation, extrait de mes lectures, pour la route...<br/><br/>
        <v-card color="blue-grey lighten-4">
          <v-card-title class="blue-grey lighten-3 indigo--text text--darken-4 mb-5 justify-space-between">
            <span>
              <u>{{ selectedQuote.from }}</u><span v-if="selectedQuote.from">,</span> {{ selectedQuote.author }}
            </span>
            <i class="fas fa-sync" @click="setRandomQuote" style="cursor: pointer"></i>
          </v-card-title>
          <v-card-subtitle class="indigo--text" v-html="selectedQuote.title"></v-card-subtitle>
          <v-card-text class="font-weight-medium black--text justify">
            <v-row>
              <v-col cols="1"></v-col>
              <v-col cols="10">
                <blockquote class="ml-12" v-html="selectedQuote.text"></blockquote>
              </v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1"></v-col>
      <v-col cols="2">
        <v-img src="@/assets/ganesh.png">
        </v-img>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import myQuotes from '@/json/my_quotes.json'
export default {
  name: 'Home',
  components: {
  },
  data: () => ({
    selectedIndex: 0,
    quotes: myQuotes,
  }),
  methods: {
    getImgBg: function()
    {
        return require('@/assets/ganesh.png')
    },
    setRandomQuote: function() {
      this.selectedIndex = getRandomIntInclusive(0, this.quotes.length-1)
    }
  },
  computed: {
    selectedQuote: function() {
      return this.quotes[this.selectedIndex]
    } 
  },
  mounted() {
    this.setRandomQuote()
  }
}

// source https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Math/random#Obtenir_un_entier_al%C3%A9atoire_dans_un_intervalle_ferm%C3%A9
function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min +1)) + min;
}
</script>